import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { selectPatientModel } from 'selectors/entitySelector';
import LOOKUP from 'constants/lookup';
import * as types from 'constants/actionTypes';
import { showSnackbar, showError } from 'actions/CommonActions';
import { signUpOnlineUser, unlockPatientAccount, patientSpringBigNotifications } from 'actions/EntityActions';
import { patientEditCrumb, patientAddCrumb } from 'utils/breadcrumbInfo';
import ValidationHelper from 'custom/validators/ValidationHelper';
import WithRouter from 'custom/withRouter';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import MaskedTextInput from 'screens/components/advanced/MaskedTextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import CheckInput from 'screens/components/basic/CheckInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import Button from 'screens/components/basic/Button';
import WebcamCapture from 'screens/components/basic/WebcamCapture';
import ToggleInput from 'screens/components/basic/ToggleInput';
import RadioInput from 'screens/components/basic/RadioInput';
import EmailInput from 'screens/components/basic/EmailInput';
import Grid from 'screens/components/basic/Grid';
// Advanced Components
import AddressInfo from 'screens/components/advanced/AddressInfo';

const pageName = "patientSave";
//component for save the Patients
class PatientSave extends Component {
    constructor(props, context) {
        super(props, context);

        this.validator = new ValidationHelper();

        //bind this to the functions
        this.savePatient = this.savePatient.bind(this);
        this.cancel = this.cancel.bind(this);
        //set initial state (ADD or EDIT)
        this.state = {
            status: "EDIT",
            value: 'a'
        };
    }

    //check if we have patientId in the URL
    componentWillMount() {
        const isPOSPage = this.props.location.pathname && this.props.location.pathname.includes("pos");
        let patientId =  this.props.patientId ? this.props.patientId : (!isPOSPage && this.props.params) ? this.props.params.id : 0;

        //if true dispatch an action to retrive patient data from API and set Status to EDIT
        if (patientId) {
            if (!this.props.memberEnabled) {
                this.props.showError(LOOKUP.authentication.unauthorizedMessage);
                setTimeout(() => {
                    this.props.navigate('/');
                }, 100);
                return;
            }
            this.setState({ status: "EDIT" });

            if (this.props.springBigEnabled) this.props.patientSpringBigNotifications({ patientId, branchId: this.props.branchId, compName: pageName });
            else this.props.getPatient(patientId);

        }
        //if false dispatch an action to clean the form and set default values, Status to ADD
        else {
            this.setState({ status: "ADD" });
            this.props.init(pageName);
        }
        //this.resetRewardForm();
    }

    //check if the Save Success or SaveError happened
    componentWillReceiveProps(newProps) {
        if (
            (newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)
            || (newProps.saveError != undefined && newProps.saveError !== this.props.saveError)
        ) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess(newProps.newId);
            else
                this.saveFailure();
        }
    }

    //call API to save the patient
    savePatient() {
        const p = this.props;
        const patient = this.props.patientModel;

        if (this.validator.validatePatient(pageName, patient, p.formError, this.props.isHighTide, this.props.isInspired) && (p.birthDateNotMandatory || this.validator.validatePatientBirthDate(pageName, patient, p.formError))) {
            this.props.savePatient(patient);
        } else if (!p.birthDateNotMandatory && !this.validator.validatePatientBirthDate(pageName, patient, p.formError)) {
            p.showSnackbar(LOOKUP.patient.overAgeErrorMessage);
        }
    }

    //when Patient is saved successfully
    saveSuccess(newId) {
        //Best to do:
        //Get the Patient ID after save and always send to the PatientView Page
        if (this.props.isDialog) {
            if (this.state.status == "ADD") {
                this.props.showError(`Member created successfully, ID is: ${newId}`);
            }
            this.props.closeDialog();
        } else {
            this.props.showPatientCreatedSnackbar(this.state.status === "EDIT" ? LOOKUP.patient.editedMessage : LOOKUP.patient.createdMessage);
            (this.state.status === "EDIT") ? this.redirectToPatientView() : this.redirectToPatientList();
        }
    }

    //When Patient is not saved, failure
    saveFailure() {
        this.props.showPatientError(LOOKUP.patient.saveErrorMessage);
    }

    //Cancel the Save form, call the parent cancel function (redirect to listing)
    cancel() {
        this.redirectToPatientList();
    }

    redirectToPatientView() {
        this.props.navigate(`/member/${this.props.patientId ? this.props.patientId : this.props.params ? this.props.params.id : 0}`);
    }

    redirectToPatientList() {
        this.props.navigate(`/member/`);
    }

    generateOnlineUser() {
        const p = this.props;
        let patient = this.props.patientModel;
        if (this.validator.validatePatient(pageName, patient, p.formError, p.isHighTide, p.isInspired) && (p.birthDateNotMandatory || this.validator.validatePatientBirthDate(pageName, patient, p.formError))) {
            let model = {
                FirstName: patient.FirstName,
                LastName: patient.LastName,
                Email: patient.Email,
                Birthday: moment(patient.DateOfBirth).format()
            }
            this.props.signUpOnlineUser(model);
        }
    }

    unlockAccount() {
        this.props.unlockAccount(this.props.patientModel.Email, pageName);
    }

    render() {
        const crumbs = this.state.status == 'ADD' ? patientAddCrumb : patientEditCrumb;
        const genders = LOOKUP.common.genders;
        const identificationTypes = LOOKUP.common.identificationTypes;
        const sbOptInSpringBig = this.props.patientModel.sbOptInSpringBig;
        const sbOptInTechPos = this.props.patientModel.sbOptInTechPos;
        const memberExistsInSpringBig = this.props.patientModel.sbPatientExists;

        // Calculate the min and max dates for patient birth date and member since
        const currentYear = new Date().getFullYear();
        const lifespan = 120; // years
        const maxDate = `${currentYear}-12-31`;
        const minDate = `${currentYear - lifespan}-01-01`;

        let dialogClass = this.props.isDialog ? "col-lg-12" : "col-lg-6";
        let dialogClass2 = this.props.isDialog ? "col-lg-12" : "col-lg-4";

        return (
            <Grid headerContent={crumbs}>
                <div className="row editPage">
                    {/* LEFT PANEL */}
                    <div className="col-12 col-sm-4 col-xs-12">
                        <div className="fixed-panel pa-2">
                            <div>
                                <WebcamCapture name={pageName + "Photo"} patientId={this.props.patientId ? this.props.patientId : this.props.params ? this.props.params.id : 0} enableDownload={this.state.status === 'EDIT' ? true : false} />
                            </div>
                            {(this.state.status === 'EDIT')
                                ?
                                <div className="ml-3">
                                    <p className="member-id-edit">ID: {this.props.patientModel.Id}</p>

                                    <ToggleInput className="patient_status btnToggleLabel" name={`${pageName}Status`} label={"Status"} />
                                    <div>
                                        {this.props.patientModel.onlineUserSignedUp &&
                                            <div>
                                                <Button name="buttonSave"
                                                    className="mb-2 patient_online_user_generated"
                                                    label={"Online User Generated (Fill Password To Reset)"}
                                                    disabled={true}
                                                    primary={true} /> <br />
                                                {
                                                    this.props.patientModel.onlineUserLockedOut &&
                                                    <Button name="buttonUnLock"
                                                        className="btnNewBrandPOS"
                                                        label={"Unlock User Account"}
                                                        primary={true}
                                                        onTouchTap={() => this.unlockAccount()} />
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                                :
                                null
                            }
                        </div>
                    </div>

                    {/* RIGHT PANEL */}
                    <div className="col-12 col-sm-8 editInfo pt-2">
                        {/* General Information */}
                        <div className="row">
                            <div className="col-lg-12 p-0">
                                <h4 className="profile-view-subtitle">General Information</h4>
                            </div>
                        </div>
                        <div className="row">
                            <div className={dialogClass}>
                                <TextInput name={pageName + "FirstName"}
                                    label={LOOKUP.patient.firstname.label}
                                    floatingLabelText={LOOKUP.patient.firstname.label}
                                    hintText={LOOKUP.patient.firstname.hintText}
                                    fullWidth={true}
                                    maxLength={50} />
                            </div>
                            <div className={dialogClass}>
                                <TextInput name={pageName + "LastName"}
                                    label={LOOKUP.patient.lastname.label}
                                    floatingLabelText={LOOKUP.patient.lastname.label}
                                    hintText={LOOKUP.patient.lastname.hintText}
                                    fullWidth={true}
                                    maxLength={50} />
                            </div>
                        </div>
                        <div className="row">
                            <div className={dialogClass}>
                                <TextInput name={pageName + 'PreferredName'}
                                    label={LOOKUP.patient.preferredName.label}
                                    floatingLabelText={LOOKUP.patient.preferredName.label}
                                    hintText={LOOKUP.patient.preferredName.hintText}
                                    fullWidth={true}
                                    maxLength={20} />
                            </div>
                            <div className={dialogClass}>
                                <TextInput name={pageName + 'CardNumber'}
                                    label={LOOKUP.patient.cardNumber.label}
                                    floatingLabelText={LOOKUP.patient.cardNumber.label}
                                    hintText={LOOKUP.patient.cardNumber.hintText}
                                    fullWidth={true} />
                            </div>
                            <div className="row">
                                <div className="col-lg-2 align-items-center">
                                    <h6 className="font-weight-light mt-0 purpleText">Gender</h6>
                                </div>
                                <div id="gender" className="col-lg-10">
                                    <RadioInput
                                        groupName={pageName + 'Gender'}
                                        options={genders}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className={dialogClass2}>
                                    <SelectInput name={pageName + 'IdentificationType'}
                                        label={LOOKUP.patient.idType.label}
                                        floatingLabelText={LOOKUP.patient.idType.label}
                                        hintText={LOOKUP.patient.idType.hintText}
                                        options={identificationTypes}
                                        fullWidth={true} />
                                </div>
                                <div className={dialogClass2}>
                                    <TextInput name={pageName + 'IdentificationNumber'}
                                        label={LOOKUP.patient.idNumber.label}
                                        floatingLabelText={LOOKUP.patient.idNumber.label}
                                        hintText={LOOKUP.patient.idNumber.hintText}
                                        fullWidth={true}
                                        maxLength={50} />
                                </div>
                                {this.props.isMedical && <div className="col-lg-4">
                                    <TextInput name={pageName + 'CareGiver'}
                                        label={LOOKUP.patient.caregiver.label}
                                        floatingLabelText={LOOKUP.patient.caregiver.label}
                                        hintText={LOOKUP.patient.caregiver.hintText}
                                        fullWidth={true}
                                        maxLength={150} />
                                </div>}
                            </div>
                            <div className="row">
                                <div className={dialogClass2}>
                                    <DatePickerInput name={pageName + 'Birthdate'}
                                        label={LOOKUP.patient.birthdate.label}
                                        floatingLabelText={LOOKUP.patient.birthdate.label}
                                        fullWidth={true}
                                        min={minDate}
                                        max={maxDate}
                                        width="140px"
                                        required={!this.props.birthDateNotMandatory}
                                    />
                                </div>
                                <div className={dialogClass2}>
                                    <DatePickerInput name={pageName + 'MemberSince'}
                                        defaultValue={new Date()}
                                        label={LOOKUP.patient.memberSince.label}
                                        floatingLabelText={LOOKUP.patient.memberSince.label}
                                        fullWidth={true}
                                        min={minDate}
                                        max={maxDate} />
                                </div>


                                <div className={`${dialogClass2} text-right`}>
                                    <CheckInput name={pageName + 'IsMember'}
                                        className="checkBox"
                                        text={'Membership?'}
                                        value={true} />
                                </div>
                            </div>


                            {/* Contact Information */}
                            <h4 className="profile-view-subtitle mt-3">Contact Information</h4>
                            <div className="row">
                                <div className={dialogClass}>
                                    <EmailInput name={pageName + 'Email'}
                                        label={LOOKUP.patient.email.label}
                                        floatingLabelText={LOOKUP.patient.email.label}
                                        hintText={LOOKUP.patient.email.hintText}
                                        maxLength={60}
                                        fullWidth={true} />
                                </div>
                                <div className={dialogClass}>
                                    <MaskedTextInput
                                        fullWidth={true}
                                        name={`${pageName}Phone`}
                                        floatingLabelText={LOOKUP.patient.phone.label}
                                        hintText={LOOKUP.patient.phone.label}
                                        maxLength={13}
                                        mask="(999)999-9999"
                                        className="text-right" />
                                </div>

                            </div>
                            <AddressInfo name={pageName} isDialog={this.props.isDialog} />
                            <div className="row">
                                <div className="col-lg-12 p-0">
                                    <h6 className="font-weight-light purpleText"> Password (Optional) </h6>
                                    {this.props.patientModel.onlineUserSignedUp ? <p>Reset Online User Password</p> : <p>Set Password To Generate Online User</p>}
                                </div>
                                <div className={dialogClass}>
                                    {/* Fake login fields for preventing autofill in browser - start */}
                                    <input
                                        type="text"
                                        name="fake-username"
                                        autoComplete="username"
                                        className="noDisplay"
                                    />
                                    <input
                                        type="password"
                                        name="fake-password"
                                        autoComplete="current-password"
                                        className="noDisplay"
                                    />
                                    {/* Fake login fields for preventing autofill in browser - end */}
                                    <TextInput name={pageName + "PatientPassword"}
                                        hintText={LOOKUP.patient.password.hintText}
                                        fullWidth={true}
                                        type="password"
                                        autoComplete="off" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 p-0">
                                    <h6 className="font-weight-light purpleText"> Preferred TechPOS Contact Method </h6>
                                </div>
                                <div className="col-lg-12 inline-checkbox-btns">
                                    <CheckInput name={pageName + 'PreferredMethodEmail'}
                                        key={LOOKUP.patient.contactMethod.email.value}
                                        text={LOOKUP.patient.contactMethod.email.text}
                                        value={LOOKUP.patient.contactMethod.email.value} />
                                    <CheckInput name={pageName + 'PreferredMethodPhone'}
                                        key={LOOKUP.patient.contactMethod.phone.value}
                                        text={LOOKUP.patient.contactMethod.phone.text}
                                        value={LOOKUP.patient.contactMethod.phone.value} />
                                    <CheckInput name={pageName + 'PreferredMethodSms'}
                                        key={LOOKUP.patient.contactMethod.sms.value}
                                        text={LOOKUP.patient.contactMethod.sms.text}
                                        value={LOOKUP.patient.contactMethod.sms.value} />
                                </div>
                            </div>
                            {
                                this.props.springBigEnabled &&
                                <div>
                                    <h4 className="profile-view-subtitle d-block purpleText">Spring Big Loyalty Program
                                        Enrollment</h4>
                                    {(this.state.status === 'ADD' || (this.state.status === 'EDIT' && memberExistsInSpringBig === false)) &&
                                        <CheckInput
                                            name={pageName + 'sbOptInTechPos'}
                                            key={LOOKUP.patient.springBig.allow.value}
                                            text={
                                                <div>
                                                    <span style={{ fontWeight: 'bold', fontSize: '15px' }}>Opt Member into the Spring Big Loyalty Rewards Program</span>
                                                    <br />
                                                    <span style={{
                                                        fontWeight: 'normal',
                                                        fontSize: '14px',
                                                    }}>{`${this.props.storeName} / Spring Big may save member's personal information for communications and to manage the member's profile.`}</span>
                                                </div>
                                            }
                                            value={LOOKUP.patient.springBig.allow.value}
                                        />
                                    }
                                    {(this.state.status === 'EDIT' && memberExistsInSpringBig === true && sbOptInSpringBig === true) &&
                                        <div>
                                            <span style={{ fontSize: '14px' }}>This member is currently enrolled in Spring Big's Loyalty Program</span>
                                            <br />
                                            <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Members must manage their Spring Big enrollment status and communication preferences using the Spring Big platform.</span>

                                            <div style={{ marginTop: '20px' }}>
                                                <CheckInput
                                                    name={pageName + 'sbOptInTechPos'}
                                                    key={LOOKUP.patient.springBig.allow.value}
                                                    text={<span style={{ fontWeight: 'bold', fontSize: '15px' }}>Send member's visit/order data to Spring Big for the purpose of accruing loyalty rewards points.</span>}
                                                    value={LOOKUP.patient.springBig.allow.value}
                                                />
                                            </div>
                                        </div>

                                    }
                                    {(this.state.status === 'EDIT' && memberExistsInSpringBig === true && sbOptInSpringBig === false) &&
                                        <div>
                                            <span style={{ fontSize: '14px' }}>This member is NOT currently enrolled in Spring Big's Loyalty Program</span>
                                            <br />
                                            <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Members must manage their Spring Big enrollment status and communication preferences using the Spring Big platform.</span>
                                        </div>
                                    }
                                </div>
                            }
                            {
                                this.props.alpineIQEnabled && this.props.alpineIQEnabled.length > 0 && this.state.status == 'ADD' &&
                                <div className="row">
                                    <div className="col-lg-12 p-0">
                                        <h4 className="font-weight-light purpleText">Alpine IQ</h4>
                                    </div>
                                    <div className="col-lg-12 p-0">
                                        <CheckInput
                                            name={pageName + 'AlpineIQLegal'}
                                            key={LOOKUP.patient.alpineIQ.allow.value}
                                            className="label-flex-wrap"
                                            text={'I consent to signup for the ' + this.props.storeName + ' rewards program where I will receive marketing communications. By doing so, I understand that I am ' +
                                                'allowing ' + this.props.storeName + ' and it\'s technology provider(s) to retain my personal contact details/ engagement history for use in personalized marketing. ' +
                                                'Opt out at any time by replying "STOP" to messages. Standard message and calling rates may apply.'}
                                            value={LOOKUP.patient.alpineIQ.allow.value}
                                        />
                                    </div>
                                </div>

                            }
                            <br />

                            {/* Additional Information */}
                            <div className="row">
                                <div className="col-lg-12 p-0">
                                    <h4 className="profile-view-subtitle">Additional Information</h4>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 p-0">
                                    <TextInput name={pageName + 'AdditionalInformation'}
                                        label="Notes"
                                        floatingLabelText="Notes"
                                        hintText="Notes"
                                        maxLength={1000}
                                        fullWidth={true}
                                    />
                                </div>
                            </div>

                            {/* Buttons */}
                            <div className="row mt-3 mb-3">
                                <div className="col-lg-12">
                                    <Button name="buttonSave"
                                        className="pull-right btnNewBrandPOS"
                                        label={LOOKUP.patient.controls.saveButton}
                                        primary={true}
                                        onTouchTap={() => this.savePatient()} />
                                    <Button name="buttonCancel"
                                        className="pull-right btn-space btnCleanSearch"
                                        label={LOOKUP.common.cancel.text}
                                        onTouchTap={() => this.props.closeDialog ? this.props.closeDialog() : this.cancel()} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    const doctorsDropDown = state.entity.doctorList.map((item) => {
        return { text: item.Name, value: item.Id };
    });
    return {
        branchId: state.common.branchId,
        patientModel: selectPatientModel(state, pageName),
        doctors: doctorsDropDown,
        saveSuccess: state.form[pageName + "SaveSuccess"],
        saveError: state.form[pageName + "SaveError"],
        ageLimit: state.common.applicationSettings.ageValidation,
        memberEnabled: state.common.applicationSettings.memberEnabled,
        isMedical: state.common.applicationSettings.isMedical,
        springBigEnabled: state.common.applicationSettings.springbigApiKey,
        alpineIQEnabled: state.common.applicationSettings.alpineIQApiKey,
        birthDateNotMandatory: state.common.applicationSettings.birthDateNotMandatory,
        storeName: state.common.store.name,
        newId: state.form[pageName + "NewId"],
        isHighTide: state.common.applicationSettings.isHighTide,
        isInspired: state.common.applicationSettings.isInspired
    };
}

function mapDispatchToProps(dispatch) {
    return {
        init: () => dispatch({ type: types.INITIALIZE_STORE_PATIENT, compName: pageName }),
        getPatient: (id) => dispatch({ type: types.PATIENT_FORM_LOAD, id: id, compName: pageName }),
        onSubmit: () => dispatch({ type: "VALIDATE", validate: true }),
        savePatient: (patient) => dispatch({ type: types.SAVE_PATIENT, patient, compName: pageName }),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
        showPatientCreatedSnackbar: (message) => dispatch({ type: types.SNACKBAR_SHOW_MESSAGE, message: message }),
        showPatientError: (message) => dispatch({ type: types.DIALOG_ALERT_OPEN, message: message }),
        showError: (message) => dispatch(showError(message)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        signUpOnlineUser: (model) => dispatch(signUpOnlineUser(model)),
        unlockAccount: (model, compName) => dispatch(unlockPatientAccount(model, compName)),
        patientSpringBigNotifications: (model) => dispatch(patientSpringBigNotifications(model))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(PatientSave));
